export default __webpack_public_path__ + "static/media/profile-picture.f7d19945.jpg";